export type BreadcrumbsDataType = {
  label: string;
  component?: any;
  componentProps?: any;
};

export enum BreadcrumbsTypeEnum {
  direction = 'direction',
  tab = 'tab',
}
